export enum Structure {
  REGULAR = 0,
  FEED = 1,
}
